import styled, { css } from 'styled-components';
import { colours, common } from 'themes/default';
import { ArrowRight } from 'react-feather';
import { BREAKPOINTS } from 'constants/breakpoints';

import { Row, Column } from 'components/shared/Layout';

const MOBILE_BREAKPOINT = `${BREAKPOINTS.lg.max}px`;

export const StyledArrowRight = styled(ArrowRight)`
  margin: 0 8px;
  height: 12px;
`;

export const StyledJourneySummary = styled.div`
  max-height: 500px;
  overflow-y: auto;
  z-index: 100;
  position: fixed;
  bottom: 0px;
  box-sizing: border-box;
  width: 100vw;
  margin-left: -8px;
  background: ${colours.Greyscale.White};
  border: solid 1px ${colours.Greyscale.CharcoalGrey};
  border-bottom: none;
  box-shadow: 0px 5px 20px #333;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    position: static;
    max-height: none;
    overflow-y: visible;
    width: auto;
    margin-left: 0;
    margin-top: 16px;
    border-bottom: solid 1px ${colours.Greyscale.CharcoalGrey};
  }
`;

export const DirectionContainer = styled(Column)`
  &:nth-child(2) {
    ${(props) => (props.show ? 'border-right: white solid 1px;' : '')};
    padding-right: 16px;
  }

  &:nth-child(3) {
    padding-left: 16px;
  }
`;

export const StyledJourneySummaryHeader = styled(Row)`
  width: 100%;
  cursor: pointer;
  padding: 8px 16px;
  box-sizing: border-box;
  background-color: ${colours.Core.CoreNavy};
  color: ${colours.Greyscale.White};
  margin: 0;
  column-gap: 0px;
  transition: background-color 0.3s ease;
  ${(props) =>
    props.isHighlighted &&
    `
    animation: smoothFlash 2s ease-in-out;
  `}

  @keyframes smoothFlash {
    0% {
      box-shadow: 0 0 0 0px ${colours.Core.CoreBlue}00;
      background-color: ${colours.Core.CoreNavy};
    }
    25% {
      box-shadow: 0 0 0 4px ${colours.Core.CoreBlue}60;
      background-color: ${colours.Core.CoreBlue};
    }
    50% {
      box-shadow: 0 0 0 6px ${colours.Core.CoreBlue}80;
      background-color: ${colours.Core.CoreBlue};
    }
    75% {
      box-shadow: 0 0 0 4px ${colours.Core.CoreBlue}60;
      background-color: ${colours.Core.CoreBlue};
    }
    100% {
      box-shadow: 0 0 0 0px ${colours.Core.CoreBlue}00;
      background-color: ${colours.Core.CoreNavy};
    }
  }
`;

export const JourneyInfoContainer = styled.div`
  max-height: 2000px;
  height: ${(props) => (props.open ? 'auto;' : '0;')};
  padding: 0px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  background: ${(props) => (props.isReturnJourney ? colours.Greyscale.White : colours.Shades.TintBlue10)};
  transition: max-height 1s ease;
  overflow: hidden;
`;

export const DirectionTotal = styled.div`
  background: ${colours.Greyscale.White};
  flex-basis: 100%;
  font-weight: 500;
  text-align: right;

  padding: 0px 16px;
  span {
    text-decoration: underline;
  }
`;

export const SegmentTotal = styled(DirectionTotal)`
  padding: 8px 0px;
`;

export const StyledJourneySegmentContainer = styled.div`
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  background: ${colours.Greyscale.White};
  flex-wrap: wrap;
  grid-column: span 1;

  ${({ empty }) =>
    empty
      ? css`
          align-items: center;
          justify-content: center;
        `
      : ''}

  .travel {
    &-summary {
      flex-basis: 100%;

      p {
        margin: 8px 0;
      }
    }

    &-date {
      font-weight: bold;
    }

    &-info {
      box-sizing: border-box;
      flex-basis: 40%;
      padding: 8px;
      background-color: ${colours.Greyscale.MistGrey};

      table {
        width: 100%;
        height: 100%;
        padding: 8px;
        background-color: ${colours.Greyscale.White};

        td {
          vertical-align: top;
          &:nth-child(2) {
            text-align: right;
          }
        }
      }

      &:not(.pax-details) {
        flex-basis: 60%;
        table {
          td {
            &:nth-child(1) {
              font-weight: 500;
            }
            &:nth-child(2) {
              text-align: left;
              padding-left: 8px;
            }
          }
        }
      }
    }
  }
`;

export const StyledTD = styled.td`
  height: 10px;
  text-align: ${({ textAlign }) => textAlign || 'initial'};
`;

export const StyledTR = styled.tr`
  vertical-align: top;
`;

export const SubmitContainer = styled.div`
  grid-column: ${({ isReturnJourney }) => (isReturnJourney ? '1 / span 2' : '1 / span 1')};
  padding: 8px 16px;
  background: ${colours.Greyscale.White};
  display: flex;
  ${({ justifyContent }) => `justify-content: ${justifyContent}`};

  button {
    margin: 0px;
  }
`;

export const SubmitButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

export const SegmentInfo = styled.div`
  flex-basis: 70%;
  background: ${colours.Greyscale.White};
  border: solid 1px ${colours.Greyscale.CharcoalGrey};
  border-radius: 5%;
`;

export const SegmentSummary = styled.div`
  flex-basis: 25%;
  background: ${colours.Greyscale.White};
  border: solid 1px ${colours.Greyscale.CharcoalGrey};
  border-radius: 5%;
`;

export const Text = styled.span`
  font-weight: ${(props) => props.weight};
  ${(prop) => (prop.underline ? 'text-decoration: underline' : '')}
`;

export const OfflineFee = styled.div`
  background: ${common.notifications.information.backgroundColour};
  border-radius: 20px;
  color: ${common.notifications.information.fontColour};
  padding: 8px 16px;
`;

export const ExposedContinueWrapper = styled(Row)`
  display: flex;
  padding-top: 50px;
`;

export const ErrorContainer = styled(Row)`
  display: flex;
  padding-bottom: 50px;
`;
